import React from 'react'

export default function TriangleAlert({ color = 'var(--color-warning)', title = '' }) {
  return (
    <i
      title={title}
      className="fa-solid fa-triangle-exclamation"
      style={{ color: color, fontSize: '0.8em', paddingLeft: '4px' }}
    ></i>
  )
}
